// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__1X_0R","input":"style_input__1zBDO"};